import styled from "styled-components";
import { useEffect, useState, useRef } from "react";
import { gql, useQuery, useMutation } from "@apollo/client";
import { captureException } from "@sentry/react";

import AdPlanPostSettings from "./AdPlanPostSettings";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import Backdrop from "components/other/Backdrop";
import MessageWindow from "components/other/MessageWindow";
import { AD_PLAN_HIGHLIGHTED_POST } from "constants";

const ModalWrap = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
`;

export default ({ profileData }) => {
  const [loadingAdPlanSettingsToggle, setLoadingAdPlanSettingsToggle] =
    useState(false);
  const [errorWindow, setErrorWindow] = useState(false);
  const [postSettingsErrorMessage, setPostSettingsErrorMessage] =
    useState(null);

  // Fetch data
  const GET_USER_DATA = gql`
    query GetUserData {
      userProfileData {
        id
        show_checkmark
        highlighted_posts
        ad_plan
      }
    }
  `;

  const { data, error, refetch } = useQuery(GET_USER_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Fetching user data error", error);
    captureException(error);
  }

  // Error handlig
  const openErrorWindow = () => {
    setErrorWindow(true);
  };

  const handleModalClose = (modal) => {
    if (modal === "error") {
      setErrorWindow(false);
    }
  };

  // handle Checkmark settings
  const TOGGLE_AD_PLAN_SETTINGS = gql`
    mutation ToggleAdPlanSettings($setting: String!) {
      toggleAdPlanSettings(setting: $setting) {
        id
        show_checkmark
        highlighted_posts
      }
    }
  `;

  const [toggleAdPlanSettings] = useMutation(TOGGLE_AD_PLAN_SETTINGS);

  const onAdPlanSettingsToggleClick = async (setting) => {
    try {
      setLoadingAdPlanSettingsToggle(true);
      setPostSettingsErrorMessage(null);
      console.log("toggling setting", setting);

      if (setting === "highlightedPosts") {
        if (data?.userProfileData.ad_plan < AD_PLAN_HIGHLIGHTED_POST) {
          setPostSettingsErrorMessage(
            "The requested feature is only part of the Gold advertising plan."
          );
          setLoadingAdPlanSettingsToggle(false);
          return;
        }
      }

      await toggleAdPlanSettings({
        variables: {
          setting,
        },
      });

      setLoadingAdPlanSettingsToggle(false);
    } catch (error) {
      console.log("error", error);
      captureException(error);
      setLoadingAdPlanSettingsToggle(false);
      openErrorWindow();
      return;
    }
  };

  console.log("data", data);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="230px" />
        </LoadingBox>
      )}
      {data && (
        <AdPlanPostSettings
          data={data}
          profileData={profileData}
          onAdPlanSettingsToggleClick={onAdPlanSettingsToggleClick}
          loadingAdPlanSettingsToggle={loadingAdPlanSettingsToggle}
          postSettingsErrorMessage={postSettingsErrorMessage}
        />
      )}
      {errorWindow && (
        <ModalWrap>
          <Backdrop
            onClick={handleModalClose}
            parameters="error"
            background="rgba(0, 0, 0, 0.7)"
          />
          <MessageWindow handleModalClose={handleModalClose} type="error" />
        </ModalWrap>
      )}
    </>
  );
};
